<template>
  <div>
    <div class="flex-container">
      <div class="table">
        <div class="title">课题得分情况</div>
        <div>
          <el-table
            :max-height="height"
            v-loading="listLoading"
            :data="resultScoreData"
            fit
            highlight-current-row
            :header-cell-style="tableHeaderColor"
            tooltip-effect="dark"
          >
            <el-table-column
              label="评委姓名"
              prop="judges"
              min-width="110px"
              align="left"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.judges }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="评审状态"
              prop="status"
              min-width="100px"
              align="left"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.status }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="提交时间"
              prop="ctime"
              min-width="100px"
              align="left"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.ctime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="打分分数"
              prop="total"
              min-width="100px"
              align="left"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <div class="result">
        <div class="title">评委评审结果和意见反馈</div>
        <div>
          <div>
            <el-tabs>
              <el-tab-pane
                v-for="(it, index) in resultJudges"
                :label="it.judges"
                :key="index"
              >
                <div class="result_content" v-html="it.feedback"></div>
                <div
                  class="result_content"
                  v-for="(item, index2) in resultDetailsData"
                  :key="index2"
                >
                  <div v-if="it.judges == item.judges">
                    <div class="label">
                      <span v-if="item.required == '1'" class="red">*</span>
                      <span>{{ item.stype }}</span>
                    </div>
                    <div class="text">
                      <div v-html="item.reference"></div>
                    </div>
                    <div style="padding: 0 15px 15px 15px">
                      <div style="color: #000; font-weight: 700">
                        {{ item.scoring_criteria }}
                      </div>
                      <div class="content_text">
                        评委打分：<label
                          style="color: red"
                          v-html="item.score + '分'"
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import { getClosingMergerResultDetails } from "@/api/course.js";

export default {
  name: "courseJxps",
  computed: { ...mapGetters(["course"]) },
  props: ["mxParams", "course"],
  data() {
    return {
      resultDetailsData: [],
      resultScoreData: [],
      resultJudges: [],
    };
  },

  created() {
    //评委委员
    const params = { cid: this.mxParams.id, type: 2, step: 16, times: 1 };
    getClosingMergerResultDetails(params).then((res) => {
      if (res.code === 0) {
        this.resultDetailsData = res.data.details;
        this.resultScoreData = res.data.score;
        this.resultJudges = res.data.judges;
      }
    });
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 42px;
  height: 42px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.table_count {
  color: #666;
  margin: 10px 15px;
}
.apply-info {
  display: flex;
  height: 44px;
  line-height: 44px;
  .item {
    padding: 0 50px;
  }
  div {
    display: flex;
  }
}
.result {
  font-size: 14px;
  .result_detail {
    color: #666;
    line-height: 32px;
    padding: 0 15px;
    .advice {
      background: #f3f3f3;
      color: #666;
      padding-left: 10px;
    }
  }
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
</style>